<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<h2 mat-dialog-title class="title"
  >D2ArmorPicker Changelog for Version {{ changelog.changelogData[0].version }}</h2
>
<mat-dialog-content class="mat-typography" style="display: flex; flex-direction: column">
  <div>
    Hi! There has been a new version of D2ArmorPicker! The following list shows all the relevant
    changes. Note that you can always look at the changelogs in the Help tab.
  </div>

  <app-changelog-list
    *ngIf="showChangelogList"
    [itemsToShow]="changelogItemsToShow"></app-changelog-list>
  <div *ngIf="!showChangelogList" style="display: flex; justify-content: center; padding: 20px">
    Loading changelog...
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="true" cdkFocusInitial color="primary" mat-raised-button
    >Thanks, I saw it!</button
  >
</mat-dialog-actions>
